import api from "@/lib/axios";
import { unwrap, unwrapList } from "@/lib/strapi";
import { withFallback, mockList, mockOne } from "@/lib/fallback";
import { mockDesigners } from "@/mocks/data";

export const designersApi = {
  list: (params = {}) =>
    withFallback(
      async () => unwrapList(await api.get("/designers", { params })),
      () => mockList(mockDesigners, params)
    ),
  get: (documentId, params = {}) =>
    withFallback(
      async () => unwrap(await api.get(`/designers/${documentId}`, { params })),
      () => mockOne(mockDesigners, documentId)
    ),
};
